export const AllVisible = function (elem, xP, yP) {
  let distance = elem.getBoundingClientRect();

  return (
    distance.top >= 0 && distance.left >= 0 && distance.bottom + xP <= window.innerHeight && distance.right + yP <= window.innerWidth
  );
};
